import React from "react";
import {BlockMath} from "react-katex";
import * as Support from "../../../canonicalNumericTaskSupport";
export const {renderInput,checkAnswer,renderAnswer,renderExplanation,renderUserAnswer}=Support;
const pick=items=>items[Math.floor(Math.random()*items.length)];

export function generateTask(options={}){
 const base=pick([2,3,5]),exponent=pick([3,4,5,6]),mode=options.mode==="quotient"?"quotient":"factor";
 const terms=mode==="factor"?2:3;
 const coefficients=Array.from({length:terms},(_,i)=>base**i);
 const answer=coefficients.reduce((a,b)=>a+b,0);
 const sum=coefficients.map((_,i)=>`${base}^{${exponent+i}}`).join("+");
 const factor=`${base}^{${exponent}}( ${coefficients.join("+")} )`;
 return {type:"PowFactorSumTask",data:{base,exponent,mode,terms,answer,sum,steps:[
  {text:"Z każdego składnika sumy wyłączamy najmniejszą wspólną potęgę. Nie dodajemy wykładników przy dodawaniu potęg.",math:`${sum}=${factor}`},
  {text:mode==="factor"?"Obliczamy współczynnik w nawiasie.":"Skracamy wspólną potęgę w liczniku i mianowniku.",math:mode==="factor"?`${coefficients.join("+")}=${answer}`:`\\frac{${factor}}{${base}^{${exponent}}}=${answer}`},
 ]}};
}
export function renderTask({data:d}){return <div><p>{d.mode==="factor"?"Uzupełnij liczbę w pustym polu po wyłączeniu wspólnego czynnika.":"Oblicz wartość wyrażenia, wyłączając wspólną potęgę z licznika."}</p><BlockMath math={d.mode==="factor"?`${d.sum}=${d.base}^{${d.exponent}}\\cdot\\boxed{\\phantom{00}}`:`\\dfrac{${d.sum}}{${d.base}^{${d.exponent}}}`}/></div>;}
export const registry={PowFactorSumTask:{generateTask,renderTask,...Support}};
